export function AppPageLoading() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-950">
      <div
        className="h-8 w-8 animate-spin rounded-full border-2 border-orange-500 border-t-transparent"
        role="status"
        aria-label="Carregando"
      />
    </div>
  );
}
